import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, Type, input, signal } from '@angular/core';

import {
  CamAddEventRequest,
  CamCalendarRessourceModel,
  CamCalendarSchedulerEventModel,
  CamSchedulerComponent,
  CamTimeRangeModel,
} from '@camelot/calendar';
import { LayoutFullPanelComponent } from '@camelot/ui';

import { CamSchedulerEventCardComponent } from '../card/scheduler/card.component';

@Component({
  selector: 'cam-planning-scheduler',
  imports: [CamSchedulerComponent, LayoutFullPanelComponent, NgTemplateOutlet],
  templateUrl: './scheduler.component.html',
  styleUrl: './scheduler.component.scss',
})
export class CamPlanningSchedulerComponent {
  planningId = input.required<string>();

  events = input.required<CamCalendarSchedulerEventModel[]>();

  resources = input.required<CamCalendarRessourceModel[]>();

  ressourceCard = input.required<Type<unknown> | null>();

  timeRanges = input.required<CamTimeRangeModel[]>();

  addEventTemplate = input.required<TemplateRef<unknown>>();

  cardComponent = input<Type<{ event: unknown }>>(CamSchedulerEventCardComponent);

  public isShowPanel = signal(false);
  public selectedPreset: CamAddEventRequest | undefined;

  public openCreatePanel(event: CamAddEventRequest) {
    this.selectedPreset = event;
    this.isShowPanel.set(true);
  }
}
